// extracted by mini-css-extract-plugin
module.exports = {"root":"LoginLayout_root__LKp4T","sidebar":"LoginLayout_sidebar__VJSqk","logo":"LoginLayout_logo__Xdt_X","imageWrapper":"LoginLayout_imageWrapper__wWFQF"};